import { render, staticRenderFns } from "./WechatPublicNumber.vue?vue&type=template&id=59a4c08b&lang=html"
import script from "./WechatPublicNumber.vue?vue&type=script&lang=js"
export * from "./WechatPublicNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports